import React, { Component } from 'react';
import Modal from './Modal';
import './popup.scss';

const defaultProps = {
  onClose: () => {}
};

/**
 * @description 弹出框组件，关闭时只是隐藏组件，而不会销毁组件
 */
export default class Popup extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { bodyStyle, ...restProps } = this.props;
    return (
      <Modal
        ref={this.popupRef}
        bodyStyle={Object.assign({ width: 274 }, bodyStyle)}
        onClose={() => this.props.onClose()}
        {...restProps}
      />
    );
  }
}

Popup.defaultProps = defaultProps;
